import { useEffect, useState } from 'react'
import { useParams, useNavigate, Link } from 'react-router-dom'
import { supabase } from '../lib/supabase'

export default function JoinWeddingPage() {
  const { token }   = useParams()
  const navigate    = useNavigate()
  const [status, setStatus]     = useState('checking') // checking | joining | success | error
  const [errorMsg, setErrorMsg] = useState('')
  const [weddingName, setWeddingName] = useState('')

  useEffect(() => {
    if (!token) { setErrorMsg('No invite token found in this link.'); setStatus('error'); return }
    handleToken()
  }, [token])

  async function handleToken() {
    // Peek at the invite to get the wedding name (for display)
    try {
      const { data: invite } = await supabase.rpc('get_partner_invite', { p_token: token })

      if (invite) {
        setWeddingName(`${invite.partner1_name}${invite.partner2_name ? ' & ' + invite.partner2_name : ''}'s wedding`)
      }
    } catch(_) {}

    // Check if user is logged in
    const { data: { user } } = await supabase.auth.getUser()

    if (!user) {
      // Not logged in — store token in localStorage then go to signup
      localStorage.setItem('okoiya_join_token', token)
      navigate('/signup?from=partner-invite', { replace: true })
      return
    }

    // Already logged in — join immediately
    await attemptJoin(token)
  }

  async function attemptJoin(t) {
    setStatus('joining')
    try {
      const { data, error } = await supabase.rpc('accept_partner_invite', { p_token: t })

      if (error) throw new Error(error.message)
      if (!data?.success) throw new Error(data?.error || 'Could not link your account to this wedding.')

      localStorage.removeItem('okoiya_join_token')

      if (data.already_linked) {
        // They already accepted before — just redirect
        window.location.href = '/dashboard'
        return
      }

      setStatus('success')
      // Redirect to dashboard after short celebration delay
      setTimeout(() => { window.location.href = '/dashboard' }, 2500)

    } catch (err) {
      setErrorMsg(err.message)
      setStatus('error')
    }
  }

  // ── Render ────────────────────────────────────────────────────
  const card = (children) => (
    <div style={{ minHeight:'100vh', background:'#FAFAF8', display:'flex', alignItems:'center', justifyContent:'center', padding:'2rem' }}>
      <div style={{ background:'white', border:'1px solid #E5E0D8', borderRadius:'1.5rem', padding:'2.5rem 2rem', maxWidth:400, width:'100%', textAlign:'center', boxShadow:'0 8px 32px rgba(0,0,0,0.06)' }}>
        {children}
      </div>
    </div>
  )

  if (status === 'checking' || status === 'joining') {
    return card(
      <>
        <div style={{ width:48, height:48, border:'3px solid #E5E0D8', borderTopColor:'#C4826A', borderRadius:'50%', animation:'spin 1s linear infinite', margin:'0 auto 1.25rem' }}/>
        <p style={{ fontFamily:'Gibs, serif', fontSize:'1.25rem', color:'#1A1A1A', margin:'0 0 0.5rem' }}>
          {status === 'checking' ? 'Checking your invite…' : 'Linking your account…'}
        </p>
        {weddingName && (
          <p style={{ fontFamily:'Nunito Sans, sans-serif', fontSize:'0.85rem', color:'#6B6B6B', margin:0 }}>for {weddingName}</p>
        )}
        <style>{`@keyframes spin{to{transform:rotate(360deg)}}`}</style>
      </>
    )
  }

  if (status === 'success') {
    return card(
      <>
        <div style={{ fontSize:'2.5rem', marginBottom:'1rem' }}>💛</div>
        <h1 style={{ fontFamily:'Gibs, serif', fontWeight:400, fontSize:'1.5rem', color:'#1A1A1A', margin:'0 0 0.5rem' }}>You're in!</h1>
        <p style={{ fontFamily:'Nunito Sans, sans-serif', fontSize:'0.9rem', color:'#6B6B6B', margin:'0 0 0.25rem', lineHeight:1.6 }}>
          Your account is now linked to {weddingName || 'your wedding'}.
        </p>
        <p style={{ fontFamily:'Nunito Sans, sans-serif', fontSize:'0.82rem', color:'#BCBCBC', margin:0 }}>
          Taking you to the dashboard…
        </p>
      </>
    )
  }

  if (status === 'error') {
    return card(
      <>
        <div style={{ fontSize:'2rem', marginBottom:'1rem' }}>🔗</div>
        <h1 style={{ fontFamily:'Gibs, serif', fontWeight:400, fontSize:'1.35rem', color:'#1A1A1A', margin:'0 0 0.75rem' }}>Something went wrong</h1>
        <p style={{ fontFamily:'Nunito Sans, sans-serif', fontSize:'0.875rem', color:'#6B6B6B', lineHeight:1.6, margin:'0 0 1.5rem' }}>
          {errorMsg}
        </p>
        <p style={{ fontFamily:'Nunito Sans, sans-serif', fontSize:'0.78rem', color:'#9B9B9B', margin:'0 0 1.25rem' }}>
          Ask your partner to send you a fresh invite link from their Settings page.
        </p>
        <Link to="/login" style={{ display:'inline-block', fontFamily:'Nunito Sans, sans-serif', fontWeight:700, fontSize:'0.875rem', color:'white', background:'#C4826A', borderRadius:100, padding:'0.75rem 1.75rem', textDecoration:'none' }}>
          Go to Login
        </Link>
      </>
    )
  }

  return null
}
